import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'

import { MsStoresLoadingProps } from '../StoreReturnsSettings'
import { StoreSuppliesSettings, SuppliesFormData } from '../StoreSuppliesSettings'

import { useApi } from '../../../hooks/storeHook'

import { WbAccountProps } from '../../../types/accountProps'

export type WildberriesSuppliesSettingsProps =
  WbAccountProps & MsStoresLoadingProps

export const WildberriesSuppliesSettings =
  observer(
    ({account, msStores, loadMsStores}: WildberriesSuppliesSettingsProps) => {
      const [selectedStatus, setSelectedStatus] = useState(account.autoCreateMoveDocsInMoySkladOnShipmentStatus)

      const api = useApi()

      const onSubmit =
        async ({autoCreateMoveDocsInMoySklad, supplyMoveSourceStoreId, supplyMoveTargetStoreId}: SuppliesFormData) => {
          await api.userSync.setWildberriesSuppliesSettings({
            accountId: account.id,
            autoCreateMoveDocsInMoySkladOnShipmentStatus: selectedStatus,
            autoCreateMoveDocsInMoySklad,
            supplyMoveSourceStoreId,
            supplyMoveTargetStoreId
          })
        }

      return (
        <StoreSuppliesSettings
          account={account}
          msStores={msStores}
          loadMsStores={loadMsStores}
          deliveryTypeHint="FBW"
          autoMoveHint="по заказам Wildberries"
          isAllowed={account.allowOptionAutoCreateMoveDocsInMoySklad}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          onSubmit={onSubmit}
        />
      )
    })